import { useParams } from 'react-router-dom';
import InteractionsComponent from '../../components/Interactions/Interactions';
import VideoComponent from '../../components/Video/Video';
import './Content.scss';
import React, { useEffect, useMemo, useState } from 'react';
import SidebarComponent from '../../components/Sidebar/Sidebar';

const ContentRoute = () => {
  const [interactionData, setInteractionData] = useState({});
  const [videoHeight, setVideoHeight] = useState(0);
  const [currentId, setCurrentId] = useState(0);
  const [clickedItem, setClickedItem] = useState(0);
  const [sidebarVisible, setSidebarVisible] = useState(false);

  const { id } = useParams();

  useEffect(() => {
    setCurrentId(id);
  }, [id]);

  const handleInteractionDetected = (data) => {
    setInteractionData(data);
  };

  const handleItemClick = (id) => {
    setClickedItem(id);
  };

  const handleSidebarVisibliity = () => {
    setSidebarVisible(!sidebarVisible);
  };

  useEffect(() => {
    // Funktion, um die Höhe des Videoelements zu aktualisieren
    const updateVideoHeight = () => {
      console.log('updateVideoHeight');
      const element = document.getElementById('video');
      if (element) {
        const elementHeight = element.offsetHeight;
        console.log('updateVideoHeight', elementHeight);
        setVideoHeight(elementHeight);
      }
    };

    // Event-Listener für die Änderung der Fenstergröße hinzufügen
    window.addEventListener('resize', updateVideoHeight);

    // Höhe des Videoelements initial aktualisieren
    setTimeout(() => {
      updateVideoHeight();
    }, 1000);

    // Event-Listener bei Komponentenunmontage entfernen
    return () => {
      window.removeEventListener('resize', updateVideoHeight);
    };
  }, [id]);

  return (
    <div className='Content'>
      <div className='container' style={{ height: `${videoHeight}px` }}>
        <div className={`sidebar-container ${sidebarVisible ? 'visible' : ''}`}>
          <SidebarComponent onItemClickHandler={handleItemClick} onSidebarVisibliity={handleSidebarVisibliity} height={videoHeight} />
        </div>
        <div className='video-container'>
          <VideoComponent onInteractionDetected={handleInteractionDetected} elementId={currentId} clickedItemId={clickedItem} />
          <InteractionsComponent interactionData={interactionData} height={videoHeight} />
        </div>
      </div>
    </div>
  );
};

export default ContentRoute;
